// extracted by mini-css-extract-plugin
export default {"windowedImage":"ImageTile-module--windowedImage--564e6"};